var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex account"},[_c('account-side'),_c('div',{staticClass:"tw-flex tw-flex-1 account__content tw-bg-white tw-overflow-y-auto tw-p-3"},[_c('div',{staticClass:"account__content__container"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }